"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const ErrorBoundaryContents_1 = require("./components/ErrorBoundaryContents");
const initialState = {
    timestamp: null,
    error: null,
};
class ErrorBoundary extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = initialState;
    }
    componentDidCatch(error) {
        this.setState({ error: error, timestamp: new Date() });
    }
    handleHome() {
        window.location.href = '/';
    }
    handleRefresh() {
        window.location.reload();
    }
    render() {
        const { error, timestamp } = this.state;
        const { children } = this.props;
        if (error) {
            return (0, jsx_runtime_1.jsx)(ErrorBoundaryContents_1.ErrorBoundaryContents, { error: error, timestamp: timestamp });
        }
        return children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
